<template>
    <div>
        <div v-if="label" class="label" >{{ label }}</div>

        <!-- description -->
        <div v-if="description" class="input-fixed-description mb-2" :class="description_class">{{ description }}</div>

        <!-- if type is text -->
        <div>
            <vs-input
                class="w-auto"
                :type="type"
                :placeholder="placeholder"
                v-model="internalValue"
                v-validate="validation"
                data-vv-validate-on="input|keyup|blur"
                :maxLength="maxLength"
                :name="errorCorrelationKey"
                ref="text-input"
                :icon="icon"
                :icon-no-border="icon ? true : false"
                icon-pack="speakol"
                :step="step"
                :data-vv-as="field"
                :id="id"
                v-bind:class="{ inputError: errors.first(this.errorCorrelationKey) }"
            />
        </div>


        <!-- error span -->
        <span class="text-danger text-sm block mt-2">{{ errors.first(this.errorCorrelationKey) }}</span>

        <!-- hint -->
        <span v-if="!errors.first(this.errorCorrelationKey) && this.hint" class="speakol-color text-sm block mt-2">{{ hint }}</span>

    </div>
</template>


<script>

export default {


  data () {
    return {}
  },


  name: 'speakol-input',
  props: {
    step: {
      type: [String, Number]
    },
    label: {
      type: [String, Number]
    },
    placeholder: {
      default: 'placeholder',
      type: [String, Number]
    },
    type: {
      default: 'text',
      type: [String]
    },
    options: {
      type: [Array]
    },
    validation: {
      type: [String]
    },
    description: {
      type: [String]
    },
    description_class: {
      type: [String],
      default: ''
    },
    hint: { type: [String] },
    value: {},
    maxLength: {
      type: [Number, String],
      default: 30
    },
    icon: { type: [String] },
    field: {
      type: [String]
    },
    correlationKey: {
      type: [String]
    },
    id: {

    }
  },

  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    errorCorrelationKey () {

      if (this.label) {
        return this.correlationKey || this.label.toLowerCase()
      }

      if (this.correlationKey) {
        return this.correlationKey
      }

      return 'key'
    }
  },


  methods: {
    async validate () {
      return await this.$validator.validate(this.errorCorrelationKey)
    },
    setDefault () {
      this.internalValue = ''
      this.$validator.reset()
    }
  }


}


</script>


<style lang="scss" scoped>
    .label {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #2c2c2c;
    }

    .input-fixed-description {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: #999;
    }

    .speakol-color {
      color: #0092d7;
    }

    .inputError {
      border: 1px solid red;
      border-radius: 6px;
    }

    /deep/ .vs-input--input {
      height: 40px !important;
      background: #fff !important;
      border: 1px solid rgba(0, 0, 0, 0.15) !important;
      box-sizing: border-box !important;
      border-radius: 4px !important;
    }

    /deep/ .input-span-placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.25);
    }

</style>
